module.exports = __webpack_public_path__ + "static/img/rong6.5524fd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rong6.jpg
// module id = KpTM
// module chunks = 52